import Follows from '../../components/pages/mypages/Follows.vue'
export default {
  components: { Follows }
}
